var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-pdf-liquidacion c-p",on:{"click":_vm.save_and_print}},[(_vm.loading)?_c('b-spinner',{attrs:{"size":"sm"}}):_c('div',[_c('i',{staticClass:"icon-print p-r-5"}),_vm._v(" PDF ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }